import { defineAction, object, string } from '~/prix'
import { appSebraeAttendanceExpression } from '~/packages/appSebrae/stats/appSebraeAttendanceStats.definition'
import searchAgentIntersections from './searchAgentIntersections.action.json'

const searchAgentIntersectionsDefinition = defineAction({
  ...(searchAgentIntersections),
  input: object({
    agentCpf: string(),
    startDate: string().isOptional(),
    endDate: string().isOptional(),
    filter: appSebraeAttendanceExpression.isOptional(),
  }),
  output: object({}),
})

export default searchAgentIntersectionsDefinition
